import { Gallery, Picture, Popover } from './Look + Feel'
import backgroundVideo_01 from './assets/background-video-01-h265.mp4'
import castelloNamestyle from './assets/castello-restaurants-namestyle.svg'
import charmFacebook from './assets/charm-facebook.svg'
import AnnouncementGrid from './Announcements'
import Galleries from './Galleries'
import { useCallback, useState } from 'react'

let PROFILE = ''
if (window.location.hostname === 'castellorestaurants.com' || window.location.hostname === 'www.castellorestaurants.com') PROFILE = 'PRODUCTION'
else if (/vercel.app$/.test(window.location.hostname)) PROFILE = 'PREVIEW'
else PROFILE = 'LOCAL'

const mapkitToken = process.env[`REACT_APP_MAPKIT_${PROFILE}`]

export default function Layout() {
	return (
		<div className='castello-restaurants'>

			<header>
				<a href='#book-now'>Book a Table Now</a>
			</header>

			<div className='video-background'>
				<video src={backgroundVideo_01} playsInline autoPlay={true} loop className='video-background' muted />
				<img className='namestyle' src={castelloNamestyle} alt='Castello Restaurants' />
			</div>

			<OurMenus />
			<AnnouncementGrid />

			<article><h1>Fine Italian &amp; Medeterranean Cuisine</h1></article>

			<MapWidget />

			<Galleries />

			<BookingWidget />

			<Footer />

			<Gallery />
			<Picture />
			<Popover />

			<Popup />
		</div>
	)
}

function OurMenus() {
	return (
		<article>
			<h1>Take your time with these new menus</h1>
			<div className='food-menu-grid'>
				<a target='_blank' rel='nofollow' href='./uploads/Menus/CastelloFoodMenu.pdf'>Castello food</a>
				<a target='_blank' rel='nofollow' href='./uploads/Menus/Castello Dessert and Beverage Menu.pdf'>Dessert &amp; beverages</a>
				<a target='_blank' rel='nofollow' href='./uploads/Menus/Castello Christmas Party Menu 2026.png'><span className='bang'>New!</span> Christmas 2026</a>
			</div>
		</article>
	)
}

function Footer() {
	return (
		<footer>
			<div className='grid'>
				<div className='column-one'>
					<h1>Castello</h1>
					<h2>Fine Italian Cuisine</h2>
					<div className='charms'>
					<a href='https://www.facebook.com/people/Castello-Restaurant-Yeovil/100063924155774/' rel='nofollow'><img src={charmFacebook} alt='Facebook' /></a>
					</div>
					<div className='details'>
						<h3>Opening times</h3>
						<p>
							Monday - Closed<br />
							Tuesday - Thursday 5pm - 10pm<br />
							Friday 5pm - 10.30pm<br />
							Saturday - 12pm - 10.30pm<br />
							Sunday - 12pm - 9.30pm
						</p>
					</div>
				</div>
				<div className='column-two'>
					<div className='labeled-details'>
						<address>
						Castello Restaurant Yeovil<br />
						3 Park Road, Yeovil, BA20 1DZ
						</address>
						<h4>Address</h4>
					</div>
					<div className='labeled-details'>
						<div>
							<a href='+441935507878'>(01935) 507878</a>
						</div>
						<h4>Phone</h4>
					</div>
					<div className='labeled-details'>
						<div>
							<a href='mailto:castelloyeovil@gmail.com'>castelloyeovil@gmail.com</a>
						</div>
						<h4>Email</h4>
					</div>
				</div>
			</div>
		</footer>
	)
}

export function MapWidget() {
	const link = `https://embed.apple-mapkit.com/v1/embed?center=50.9428871%2C-2.6341301&cameraDistance=2000&annotations=%5B%7B%22place%22%3A%22I9CD722556B4162D1%22%7D%5D&language=en-GB&colorScheme=adaptive&t=mutedStandard&token=${mapkitToken}`
	return (
		<div className='map-widget'>
			<iframe title='Map widget' className='widget' src={link} width="1080" height="320"></iframe>
		</div>
	)
}

export function BookingWidget() {
	return (
		<div className='booking-widget' id='book-now'>
			<iframe title='Booking widget' className='widget' src='https://web.dojo.app/create_booking/vendor/njESWPD80Vr1NC634kJSWt2c5SF43U3opqy3PP2QxxM_restaurant'></iframe>
		</div>
	)
}

function Popup() {
	const [ isClosed, setIsClosed ] = useState(false)
	const close = useCallback(() => {
		setIsClosed(true)
	}, [ ])
	if (isClosed) return null
	return (
		<div className='notice'>
			Please note: <strong>This website is for our Yeovil restaurant only.</strong>
			<div className='options'>
				<button className='close-button' onClick={close}>Close</button>
			</div>
		</div>
	)
}
